export var EStatus;
(function (EStatus) {
  EStatus["Added"] = "added";
  EStatus["Available"] = "available";
  EStatus["Unavailable"] = "unavailable";
})(EStatus || (EStatus = {}));